// src/services/validateToken.js
import {
  validateGoogleToken,
  isGoogleAuthenticated,
} from "./googleAuthService";

// Env (proxy): VITE_API_BASE=/phapiv2, optional override for route
const base = import.meta.env.VITE_API_BASE;
const apiManagerRoute = import.meta.env.VITE_MANAGER_ROUTE;

const validateToken = async () => {
  if (isGoogleAuthenticated()) {
    return await validateGoogleToken();
  }

  const token = localStorage.getItem("jwtToken");
  if (!token) return false;

  try {
    const res = await fetch(`${base}/${apiManagerRoute}/ValidateManager`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return res.ok;
  } catch (err) {
    console.error("Error validating token:", err);
    return false;
  }
};

export default validateToken;
